const PRODUCT_CONST = {
    HOME_PRODUCTS: "HOME_PRODUCTS",
    PRODUCT_SELECTED: "PRODUCT_SELECTED"
}

export default PRODUCT_CONST;